import { render, staticRenderFns } from "./UserProfile.vue?vue&type=template&id=313ca8c4&scoped=true"
import script from "./UserProfile.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserProfile.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./UserProfile.vue?vue&type=style&index=0&id=313ca8c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313ca8c4",
  null
  
)

export default component.exports